import styled from 'styled-components';

import { CustomThemeToken } from '@/theme';

interface MetricsContainerProps {
  theme: { token: CustomThemeToken };
  $hasSlider?: boolean;
}

interface SliderContainerProps {
  theme: { token: CustomThemeToken };
}

export const SliderContainer = styled.div<SliderContainerProps>`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  max-width: 100%;

  .details-widget-slider {
    background-color: ${({ theme: { token } }) => token.colorBgElevated};
    
    .slider-container {
      padding: 0 ${({ theme: { token } }) => token.paddingXL}px;  
      /* Clip only left/right overflow (keep top/bottom labels visible) */
      clip-path: inset(-9999px 0 -9999px 0);

      .value {
        margin-bottom: 0;

        .value-content {
          font-size: ${({ theme: { token } }) => token.fontSizeXL}px;
        }

        .units-sign {
          bottom: 4px;
        }
      }

      .slider {
        &:before {
          margin-left: -16.2601626%;
          width: 16.2601626%;
        }

        &:after {
          margin-right: -16.2601626%;
          width: 16.2601626%;
        }
      }

      .triangle {
        height: 8px;
        width: 12px;
        margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .points {
        .point-value {
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
          margin-top: ${({ theme: { token } }) => token.marginXXS}px;
        }

        .label {
          font-size: ${({ theme: { token } }) => token.fontSizeSM}px;
        }
      }
    }
  }
`;

export const MetricsContainer = styled.div<MetricsContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  flex-wrap: wrap;
  align-content: flex-start;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  margin-top: ${({ theme: { token }, $hasSlider }) => ($hasSlider ? token.marginXXL : 0)}px;
  max-height: ${({ theme: { token } }) => token.padding * 10 - 10}px;
  overflow-y: auto;
  overflow-x: hidden;
`;